/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summarysourceothersite3Inputs */

const en_summarysourceothersite3 = /** @type {(inputs: Summarysourceothersite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other websites`)
};

const de_summarysourceothersite3 = /** @type {(inputs: Summarysourceothersite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere Webseiten`)
};

/**
* | output |
* | --- |
* | "Other websites" |
*
* @param {Summarysourceothersite3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summarysourceothersite3 = /** @type {((inputs?: Summarysourceothersite3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summarysourceothersite3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summarysourceothersite3(inputs)
	return de_summarysourceothersite3(inputs)
});
export { summarysourceothersite3 as "summarySourceOtherSite" }